<template>
    <div class="login-page">
        <div class="login-container">
            <!-- Kolom Ilustrasi -->
            <div class="illustration-section">
                <div class="illustration-content">
                    <img src="@/assets/images/ipc-logo-2.png" alt="IPC Logo" class="ipc-logo" width="160" height="160"/>
                    <h3>International Pepper Community</h3>
                    <p>We are the #UNESCAP agency responsible for the development of the global pepper industry.</p>
                </div>
            </div>

            <!-- Kolom Form Login -->
            <div class="login-form-section">
                    <div class="login-card">
                        <div class="card-header">
                            <p class="eyebrow">IPC ADMIN PORTAL</p>
                            <h2>Admin sign in</h2>
                            <p class="login-intro">Use your administrator account to continue.</p>
                        </div>

                    <div
                        v-if="ui.error"
                        id="login-error"
                        ref="errorAlert"
                        class="alert-container"
                        role="alert"
                        aria-live="assertive"
                        tabindex="-1"
                    >
                        <div class="alert-content">
                            <span>{{ ui.message }}</span>
                            <button class="close-alert" type="button" aria-label="Dismiss error message" @click="ui.error = false">
                                <i class="pi pi-times" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>

                    <form class="signin-form" @submit.prevent="onSubmit">
                        <div class="form-group">
                            <label for="username">Username</label>
                            <div class="input-wrapper">
                                <input id="username" type="text" class="form-control" autocomplete="username" v-model="model.username" required>
                                <i class="input-icon pi pi-user" aria-hidden="true"></i>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="password">Password</label>
                            <div class="input-wrapper">
                                <input
                                    id="password"
                                    :type="showPassword ? 'text' : 'password'"
                                    class="form-control"
                                    autocomplete="current-password"
                                    v-model="model.password"
                                    required
                                >
                                <i class="input-icon pi pi-lock" aria-hidden="true"></i>
                                <button
                                    class="password-toggle"
                                    type="button"
                                    :aria-label="showPassword ? 'Hide password' : 'Show password'"
                                    :aria-pressed="showPassword"
                                    @click="showPassword = !showPassword"
                                >
                                    <i :class="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn-submit" :disabled="ui.loading">
                                <span v-if="!ui.loading">Sign in</span>
                                <span v-else class="spinner" role="status" aria-label="Signing in"></span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import apiService from "@/services/ApiService";

export default defineComponent({
    name: "LoginPage",
    data() {
        return {
            model: {
                username: '',
                password: ''
            },
            ui: {
                error: false,
                message: '',
                loading: false,
            },
            showPassword: false
        }
    },
    methods: {
        onSubmit() {
            this.ui.loading = true;
            this.ui.error = false;

            const payload = {
                username: this.model.username,
                password: this.model.password
            };

            apiService.post('/login', payload).then(response => {
                this.$store.dispatch('onLoggedIn', response.data)
                this.$router.push('/')
            }).catch(error => {
                console.error(error);
                this.ui.error = true;
                if (error.response && error.response.status === 404) {
                    this.ui.message = 'Request not found';
                } else if (error.response && error.response.data && error.response.data.Message) {
                    this.ui.message = error.response.data.Message;
                } else {
                    this.ui.message = 'An unexpected error occurred.';
                }
                this.$nextTick(() => this.$refs.errorAlert?.focus());
            }).finally(() => {
                this.ui.loading = false;
            });
        }
    }
})
</script>

<style scoped>
.login-page {
    background-color: #f0f2f5;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    padding: 2rem;
}

.login-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    max-width: 1100px;
    min-height: 600px;
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

/* Kolom Ilustrasi (Kiri) */
.illustration-section {
    background: linear-gradient(135deg, #e6f2ff 0%, #d9e8ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    text-align: center;
}

.illustration-content h3 {
    color: #005ecb;
    font-size: 1.5rem;
    font-weight: 600;
    margin-top: 1.5rem;
}

.illustration-content p {
    color: #007aff;
    font-size: 1rem;
}

.illustration-svg {
    width: 150px;
    height: auto;
    opacity: 0.8;
}

/* Kolom Form (Kanan) */
.login-form-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem;
}

.login-card {
    width: 100%;
    max-width: 380px;
}

.card-header {
    text-align: left;
    margin-bottom: 1.75rem;
}

.eyebrow {
    margin: 0 0 0.5rem;
    color: #005ecb;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.08em;
}

.card-header h2 {
    font-size: 1.5rem;
    font-weight: 600;
    color: #1c1c1e;
    position: relative;
    padding-left: 1rem;
    margin: 0;
}

.login-intro {
    color: #5d6470;
    font-size: 0.95rem;
    line-height: 1.5;
    margin: 0.75rem 0 0;
}

.card-header h2::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 24px;
    background-color: #007aff;
    border-radius: 2px;
}

.form-group {
    margin-bottom: 1.5rem;
}

.form-group label {
    color: #30343b;
    display: block;
    font-size: 0.9rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.input-wrapper {
    position: relative;
}

.form-control {
    width: 100%;
    padding: 0.85rem 3rem 0.85rem 3rem;
    font-size: 1rem;
    border: 1px solid #dcdce1;
    border-radius: 12px;
    box-sizing: border-box;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.form-control:focus {
    outline: none;
    border-color: #007aff;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
}

.input-icon {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    color: #8e8e93;
    font-size: 1rem;
}

.password-toggle {
    align-items: center;
    background: transparent;
    border: 0;
    border-radius: 6px;
    color: #5d6470;
    cursor: pointer;
    display: flex;
    height: 32px;
    justify-content: center;
    padding: 0;
    position: absolute;
    right: 0.65rem;
    top: 50%;
    transform: translateY(-50%);
    width: 32px;
}

.password-toggle:hover {
    background: #edf4ff;
    color: #005ecb;
}

.password-toggle:focus-visible,
.close-alert:focus-visible,
.btn-submit:focus-visible {
    outline: 3px solid rgba(0, 122, 255, 0.35);
    outline-offset: 2px;
}

.btn-submit {
    width: 100%;
    padding: 0.9rem;
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: #fff;
    background-color: #007aff;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    transition: background-color 0.2s, transform 0.1s;
    min-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-submit:hover:not(:disabled) {
    background-color: #005ecb;
}

.btn-submit:active:not(:disabled) {
    transform: scale(0.98);
}

.btn-submit:disabled {
    background-color: #a0cffa;
    cursor: not-allowed;
}

.form-footer {
    text-align: center;
    margin-top: 1rem;
}

.forgot-password {
    color: #007aff;
    text-decoration: none;
    font-size: 0.9rem;
}

.forgot-password:hover {
    text-decoration: underline;
}

.page-footer {
    position: absolute;
    bottom: 2rem;
    text-align: center;
    font-size: 0.8rem;
}

.page-footer a {
    color: #8e8e93;
    text-decoration: none;
    margin: 0 0.5rem;
}

.page-footer a:hover {
    text-decoration: underline;
}

/* Alert Styles */
.alert-container {
    background-color: #fff1f1;
    border: 1px solid #f5c2c7;
    border-radius: 8px;
    padding: 0.75rem 1rem;
    margin-bottom: 1.5rem;
}

.alert-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #c62828;
    font-size: 0.9rem;
}

.close-alert {
    align-items: center;
    background: none;
    border: none;
    color: #c62828;
    cursor: pointer;
    display: flex;
    height: 32px;
    justify-content: center;
    margin-left: 0.75rem;
    padding: 0;
    width: 32px;
}

/* Spinner */
.spinner {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

/* Responsive */
@media (max-width: 992px) {
    .login-container {
        grid-template-columns: 1fr;
        min-height: auto;
        border-radius: 0;
        box-shadow: none;
    }
    .illustration-section {
        display: none; /* Sembunyikan ilustrasi di layar kecil */
    }
    .login-form-section {
        justify-content: center;
        min-height: auto;
        padding: 2rem 1.5rem;
    }
    .login-page {
        min-height: 100dvh;
        padding: 0;
        background: #fff;
    }
}

@media (prefers-reduced-motion: reduce) {
    .form-control,
    .btn-submit {
        transition: none;
    }

    .spinner {
        animation: none;
    }
}
</style>
